import React, { useEffect, useState } from 'react';
import moment from 'moment-timezone';
import ReactTable from "react-table";
import { PastChecklistsService } from '../../services';
import i18next from "i18next";

const DAY_OF_WEEK_NAME_ORDER = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

const AllChecklistReportResultDOWColumn = ({ dowEntry }) => (
    <div>
        {dowEntry?.totalCount ?? 0}&nbsp;/&nbsp;
        {dowEntry?.completedCount ?? 0} ({(dowEntry?.totalCount ?? 0) == 0 ? 0 : Math.round(((dowEntry?.completedCount ?? 0) / (dowEntry?.totalCount ?? 0)) * 100.0)}%) <br />
        {dowEntry?.correctiveActionCount ?? 0}
    </div>
);

const AllChecklistReportResultTotalColumn = ({entries}) => {
    var totalCount = 0;
    var completedCount = 0;
    var correctiveActionCount = 0;

    Object.values(entries).forEach((dowEntry) => {
        totalCount += dowEntry.totalCount ?? 0;
        completedCount += dowEntry.completedCount ?? 0;
        correctiveActionCount += dowEntry.correctiveActionCount ?? 0;
    });

    return (
        <div>
            {totalCount}&nbsp;/&nbsp;
            {completedCount} ({totalCount == 0 ? 0 : Math.round((completedCount / totalCount) * 100.0)}%) <br />
            {correctiveActionCount}
        </div>
    );
};

const AllChecklistReportResults = ({ query }) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (query.location && query.startAtDate) {
            setLoading(true);

            const DATE_FORMAT = 'L';
            const startAtDate = moment(query.startAtDate, DATE_FORMAT).utc().startOf("day").valueOf();
            const endAtDate = moment(query.startAtDate, DATE_FORMAT).add(6, "day").utc().endOf("day").valueOf();

            const options = [
                { groupingId: query.location.id },
                { startDate: startAtDate },
                { endDate: endAtDate }
            ];

            PastChecklistsService.getAllChecklistsReport(options)
                .then(({response}) => {
                    setData(Object.values(response.data.countByChecklistId).sort((a, b) => a.name.localeCompare(b.name)));
                    setLoading(false);
                })
                .catch((error) => {
                    console.error(error);
                    setLoading(false);
                });
        }
    }, [query]);

    const createColumns = () => {
        let columns = [{
            Header: 'Checklist',
            accessor: "name",
            Cell: ({value, original}) => `${value} (V${original.version})`,
            minWidth: 80,
            minResizeWidth: 180,
            width: 220,
            sortable: true
        }];

        DAY_OF_WEEK_NAME_ORDER.forEach((dowName) => {
            columns.push({
                Header: dowName,
                accessor: dowName,
                Cell: ({original}) => <AllChecklistReportResultDOWColumn dowEntry={original.dowEntries[dowName]} />,
                width: 115,
                sortable: false
            });
        });

        columns.push({
            Header: 'Total',
            Cell: ({original}) => <AllChecklistReportResultTotalColumn entries={original.dowEntries} />,
            width: 115,
            sortable: false
        });

        return columns;
    };

    if (loading) {
        return <div className="loader">{i18next.t("loading")}</div>;
    } else if (data.length === 0) {
        return (
            <div>
                <p>No checklist data found.</p>
            </div>
        );
    } else {
        return (
            <div>
                <div className="op-content-box">
                    <ul className="list-inline clearfix">
                        <li className="pull-left box-label">
                            <h4 className="remove-margin-bottom">{i18next.t("results")}</h4>
                        </li>
                    </ul>

                    <div>
                        <div>
                            <b>Legend</b> <br/>
                            Started Count / Completed Count (Completed %) <br/>
                            Corrective Actions Count
                        </div>
                        <div className="react-table-custom">
                            <ReactTable
                                    className="-striped -highlight"
                                    data={data}
                                    showPagination={false}
                                    pageSize={data.length}
                                    defaultSorted={[{
                                        id: 'name',
                                        desc: false // not necessary unless set to true, but it's good to know its there.
                                    }]}
                                    columns={createColumns()}
                                />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
};

export default AllChecklistReportResults;
